module.exports = __webpack_public_path__ + "media/images/oauth/bigcommerce_canada-cb18a94b90f4c6b60930e72addcc6297.png";